import { render, staticRenderFns } from "./IcoCheckCircleDash.vue?vue&type=template&id=2b43f460"
import script from "./IcoCheckCircleDash.vue?vue&type=script&lang=js"
export * from "./IcoCheckCircleDash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports